export interface ActivityCategory {
  label: string;
  activities: ActivityType[];
}

export interface ActivityType {
  value: string;
  label: string;
}

export const activityCategories: ActivityCategory[] = [
  {
    label: "Marketing & Media",
    activities: [
      { value: "professional_photography", label: "Professional Photography" },
      { value: "drone_photography", label: "Drone Photography" },
      { value: "video_walkthrough", label: "Video Walkthrough" },
      { value: "virtual_tour_created", label: "Virtual Tour Created" },
      { value: "floor_plan_created", label: "Floor Plan Created" },
      { value: "brochure_flyer_created", label: "Brochure / Flyer Created" },
      { value: "social_media_post", label: "Social Media Post" },
      { value: "email_blast_sent", label: "Email Blast Sent" },
      { value: "just_listed_campaign", label: "Just Listed Campaign" },
      { value: "price_improvement_campaign", label: "Price Improvement Campaign" },
    ],
  },
  {
    label: "Listing Prep & MLS",
    activities: [
      { value: "listed_on_mls", label: "Listed on MLS" },
      { value: "mls_listing_updated", label: "MLS Listing Updated" },
      { value: "price_change", label: "Price Change" },
      { value: "yard_sign_installed", label: "Yard Sign Installed" },
      { value: "lockbox_installed", label: "Lockbox Installed" },
      { value: "staging_completed", label: "Staging Completed" },
      { value: "pre_listing_inspection", label: "Pre-Listing Inspection" },
    ],
  },
  {
    label: "Communication & Outreach",
    activities: [
      { value: "seller_update_call", label: "Seller Update Call" },
      { value: "seller_meeting", label: "Seller Meeting" },
      { value: "agent_to_agent_outreach", label: "Agent-to-Agent Outreach" },
      { value: "broker_tour_caravan", label: "Broker Tour / Caravan" },
      { value: "neighborhood_outreach", label: "Neighborhood Outreach" },
      { value: "showing_feedback_followup", label: "Showing Feedback Follow-Up" },
    ],
  },
  {
    label: "Offers & Negotiation",
    activities: [
      { value: "offer_received", label: "Offer Received" },
      { value: "counteroffer_sent", label: "Counteroffer Sent" },
      { value: "offer_accepted", label: "Offer Accepted" },
      { value: "offer_rejected", label: "Offer Rejected" },
    ],
  },
  {
    label: "Contract & Closing",
    activities: [
      { value: "under_contract", label: "Under Contract" },
      { value: "inspection_scheduled", label: "Inspection Scheduled" },
      { value: "appraisal_scheduled", label: "Appraisal Scheduled" },
      { value: "repair_negotiation", label: "Repair Negotiation" },
      { value: "closing_scheduled", label: "Closing Scheduled" },
      { value: "closed_sold", label: "Closed / Sold" },
    ],
  },
  {
    label: "Other",
    activities: [
      { value: "other", label: "Other" },
    ],
  },
];

// Flat lookup for getting label from value
export const activityLabelMap: Record<string, string> = Object.fromEntries(
  activityCategories.flatMap((cat) =>
    cat.activities.map((a) => [a.value, a.label])
  )
);

export function getActivityLabel(value: string): string {
  return activityLabelMap[value] || value;
}
